module.exports = __webpack_public_path__ + "img/check-icon-green.13abe115.svg";